function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { Button, Callout, Typography } from 'seagull';
import { useStoreActions } from "../../../../contexts";
import { useNonNullableRelationship } from "../../../../hooks/reactQuery/queries/useRelationship";
import { getAccountingDetails } from "../../../../integrations/Accounting/accounting.utils";
import { useOpenMapServicesModal } from "../../../../integrations/Accounting/MapServicesModal/useOpenMapServicesModal";
import { Accounting } from "../../../../types/api.model";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MapServicesCallout(_ref) {
  let {
    accounting,
    relationshipId
  } = _ref;
  const {
    fetchQboTimeActivities
  } = useStoreActions();
  const {
    relationship,
    optimisticUpdate
  } = useNonNullableRelationship(relationshipId);
  const setServiceIntegratedId = useMemo(() => {
    switch (accounting) {
      case Accounting.QBO:
        return (integrations, integratedId) => integrations.setQboIntegratedId(integratedId);
      case Accounting.Xero:
        return (integrations, integratedId) => integrations.setXeroIntegratedId(integratedId);
    }
  }, [accounting]);
  const serviceTemplateIds = getAccountingDetails(accounting).policy.getServiceTemplateIdsFromServices(relationship.services);
  const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, async change => {
    if (accounting === Accounting.QBO) await fetchQboTimeActivities(relationshipId);
    optimisticUpdate(agreement => _objectSpread(_objectSpread({}, agreement), {}, {
      services: agreement.services.map(service => service.serviceTemplateId === change.serviceTemplateId ? _objectSpread(_objectSpread({}, service), {}, {
        integrations: setServiceIntegratedId(service.integrations, change.accountingItemId)
      }) : service)
    }));
  });
  return /*#__PURE__*/_jsx(Callout, {
    withAction: /*#__PURE__*/_jsx(Button, {
      testId: "map-services-".concat(accounting),
      onClick: () => openMapServicesModal(accounting),
      children: "Map services"
    }),
    children: /*#__PURE__*/_jsxs(Typography, {
      testId: "map-services-callout-".concat(accounting),
      children: ["Some services are not mapped to ", getAccountingDetails(accounting).fullName, "."]
    })
  });
}